import React from 'react';
import { Link } from 'react-router-dom';

const DeleteAccount = () => {
  return (
    <div className="min-h-screen" style={{background: 'linear-gradient(135deg, var(--app-color), #8B5CF6)'}}>
      {/* Header */}
      <header className="bg-white/90 backdrop-blur-sm border-b border-white/20">
        <div className="max-w-6xl mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className="w-8 h-8 rounded-lg flex items-center justify-center" style={{background: 'var(--app-color)'}}>
                <span className="text-white font-bold text-lg">E</span>
              </div>
              <h1 className="text-xl font-bold text-gray-900">Esti.kz</h1>
            </div>
            <Link 
              to="/" 
              className="text-sm font-medium px-4 py-2 rounded-lg transition-all duration-200 hover:scale-105 active:scale-95 flex items-center gap-2"
              style={{background: 'var(--app-color)', color: 'white'}}
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
              </svg>
              Басты бетке оралу
            </Link>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="max-w-4xl mx-auto px-4 py-8">
        <div className="bg-white/90 backdrop-blur-sm rounded-xl shadow-lg p-6 border border-white/20 mb-6">
          <h1 className="text-3xl font-bold mb-6 text-gray-900">
            Тіркелгіні жою / Account Deletion
          </h1>

          <p className="text-gray-700 leading-relaxed mb-4">
            Бұл бет тіркелгіңізді қалай жою керектігі туралы ақпаратты береді.
            <br />
            This page provides information on how to delete your account.
          </p>

          <h2 className="text-xl font-semibold text-gray-900 mt-6 mb-3">
            Тіркелгіні жою қадамдары / Steps to Delete Your Account:
          </h2>
          <ol className="list-decimal list-inside space-y-3">
            <li>
              <div className="font-semibold text-gray-900">
                Қолданба арқылы / Through the App:
              </div>
              <p className="text-gray-700 leading-relaxed mt-2">
                1. Қолданбадағы "Параметрлер" (Settings) бөліміне өтіңіз.
                <br />
                Go to the "Settings" section within the app.
              </p>
              <p className="text-gray-700 leading-relaxed">
                2. "Тіркелгіні жою" (Delete Account) опциясын табыңыз және басыңыз.
                <br />
                Find and tap on the "Delete Account" option.
              </p>
              <p className="text-gray-700 leading-relaxed">
                3. Жоюды растау үшін нұсқауларды орындаңыз.
                <br />
                Follow the prompts to confirm the deletion.
              </p>
            </li>
            <li>
              <div className="font-semibold text-gray-900">
                Қолдау қызметіне хабарласу арқылы / By Contacting Support:
              </div>
              <p className="text-gray-700 leading-relaxed mt-2">
                Егер қолданба арқылы жою мүмкін болмаса немесе сізде сұрақтар
                туындаса, біздің қолдау қызметіне хабарласыңыз:
                <br />
                If deleting through the app is not possible or you have further
                questions, please contact our support team at:
                <br />
                <a
                  href="mailto:musaaldanazarov@gmail.com"
                  className="font-medium transition-colors hover:opacity-80"
                  style={{color: 'var(--app-color)'}}
                >
                  musaaldanazarov@gmail.com
                </a>
                <br />
                немесе біздің Жиі қойылатын сұрақтар бетіне кіріңіз:
                <br />
                or visit our FAQ page for more information:
                <br />
                <a
                  href="https://esti.kz/faq"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="font-medium transition-colors hover:opacity-80"
                  style={{color: 'var(--app-color)'}}
                >
                  https://esti.kz/faq
                </a>
              </p>
              <p className="text-gray-700 leading-relaxed">
                Сіздің сұрауыңызды өңдеу үшін тіркелгіңізбен байланысты
                электрондық пошта мекенжайын немесе пайдаланушы атын көрсетіңіз.
                <br />
                Please provide your email address or username associated with
                your account to help us process your request.
              </p>
            </li>
          </ol>

          <h2 className="text-xl font-semibold text-gray-900 mt-6 mb-3">
            Маңызды ескертулер / Important Notes:
          </h2>
          <ul className="list-disc list-inside space-y-3">
            <li>
              <p className="text-gray-700 leading-relaxed">
                Тіркелгіңізді жойғаннан кейін, сіздің барлық деректеріңіз бен
                сатып алуларыңыз өшірілуі мүмкін.
                <br />
                Once your account is deleted, all your data and purchases may be
                permanently removed.
              </p>
            </li>
            <li>
              <p className="text-gray-700 leading-relaxed">
                Бұл процесс біраз уақыт алуы мүмкін.
                <br />
                This process may take some time to complete.
              </p>
            </li>
            <li>
              <p className="text-gray-700 leading-relaxed">
                Жою туралы сұрауды жібермес бұрын, маңызды деректерді
                сақтағаныңызға көз жеткізіңіз.
                <br />
                Please ensure you have backed up any important data before
                submitting a deletion request.
              </p>
            </li>
            <li>
              <p className="text-gray-700 leading-relaxed">
                Деректерді жою сұрауының өңделуі туралы қосымша ақпаратты
                <a
                  href="https://us-central1-tynda-65659.cloudfunctions.net/esti-server/users/uid"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="font-medium transition-colors hover:opacity-80"
                  style={{color: 'var(--app-color)'}}
                >
                  {' '}осы сілтемеден
                </a>
                {' '}таба аласыз (бұл API соңғы нүктесі, тікелей веб-бет емес, тек
                техникалық анықтама үшін).
                <br />
                Further information regarding the processing of data deletion
                requests can be found at
                <a
                  href="https://us-central1-tynda-65659.cloudfunctions.net/esti-server/users/uid"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="font-medium transition-colors hover:opacity-80"
                  style={{color: 'var(--app-color)'}}
                >
                  {' '}this link
                </a>
                {' '}(this is an API endpoint, not a direct web page, for technical
                reference only).
              </p>
            </li>
          </ul>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-white/10 backdrop-blur-sm border-t border-white/20 py-6 mt-8">
        <div className="max-w-6xl mx-auto px-4">
          <div className="text-center">
            <p className="text-white/80 text-sm">
              © {new Date().getFullYear()} Esti.kz. Барлық құқықтар қорғалған.
            </p>
            <p className="text-xs text-white/60 mt-1">
              Отбасы хрестоматиясы
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default DeleteAccount;